import { render, staticRenderFns } from "./vue-draggable-resizable.vue?vue&type=template&id=fb649f92&scoped=true&lang=pug"
import script from "./vue-draggable-resizable.vue?vue&type=script&lang=js"
export * from "./vue-draggable-resizable.vue?vue&type=script&lang=js"
import style0 from "./vue-draggable-resizable.vue?vue&type=style&index=0&id=fb649f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb649f92",
  null
  
)

export default component.exports